import { updateItems } from '@/mocks/homeData';

const updateImages = [
  'https://readdy.ai/api/search-image?query=warm%20toned%20night%20city%20scene%20with%20soft%20bokeh%20lights%2C%20crimson%20and%20amber%20mood%2C%20abstract%20urban%20night%2C%20editorial%20style%2C%20no%20text%2C%20mysterious%20atmosphere&width=400&height=260&seq=update-01-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=dark%20warm%20toned%20abstract%20composition%20with%20crimson%20glow%2C%20soft%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20no%20text%2C%20mysterious%20elegant&width=400&height=260&seq=update-02-51cg&orientation=landscape',
  'https://readdy.ai/api/search-image?query=warm%20dramatic%20abstract%20scene%2C%20dark%20amber%20and%20crimson%20gradients%2C%20soft%20bokeh%2C%20cinematic%20mood%2C%20editorial%20style%2C%20no%20text&width=400&height=260&seq=update-03-51cg&orientation=landscape',
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full bg-background-100 py-14 md:py-20 px-4 md:px-6 lg:px-10">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-6 mb-10 md:mb-14">
          <div className="lg:w-1/3">
            <h2 className="text-foreground-950 font-heading font-bold text-3xl md:text-4xl leading-tight">
              最新快讯
              <br />
              爆料实时追踪
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              全天候滚动更新的娱乐八卦与网红黑料快讯，编辑团队24小时轮班监控全网动态，确保您第一时间获取最新爆料信息。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          <div className="bg-background-800 rounded-2xl p-5 md:p-6 space-y-5">
            {updateItems.slice(0, 3).map((item, idx) => (
              <a key={idx} href="#updates" className="block group cursor-pointer">
                <div className="flex items-start gap-3 mb-2">
                  <span className="inline-block bg-accent-500 text-foreground-950 text-xs font-bold px-2 py-0.5 rounded whitespace-nowrap flex-shrink-0">
                    {item.tag}
                  </span>
                  <h3 className="text-white font-semibold text-sm md:text-base leading-snug group-hover:text-accent-300 transition-colors">
                    {item.title}
                  </h3>
                </div>
                <p className="text-white/50 text-xs ml-0">{item.desc}</p>
                {idx === 0 && (
                  <img
                    src={updateImages[0]}
                    alt={item.title}
                    className="w-full h-40 object-cover rounded-lg mt-3"
                  />
                )}
              </a>
            ))}
          </div>

          <div className="space-y-4 md:space-y-5">
            {updateItems.slice(3, 6).map((item, idx) => (
              <a key={idx} href="#updates" className="block bg-background-50 rounded-xl p-4 md:p-5 hover:bg-background-200 transition-colors cursor-pointer">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-bold px-2 py-0.5 rounded mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="flex items-start gap-3">
                  <img
                    src={updateImages[idx % 3]}
                    alt={item.title}
                    className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover flex-shrink-0"
                  />
                  <div className="min-w-0">
                    <h3 className="text-foreground-900 font-semibold text-sm leading-snug mb-1">
                      {item.title}
                    </h3>
                    <p className="text-foreground-400 text-xs">{item.desc}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>

          <div className="space-y-4 md:space-y-5">
            {updateItems.slice(6, 8).map((item, idx) => (
              <a key={idx} href="#updates" className="block bg-background-50 rounded-xl p-4 md:p-5 hover:bg-background-200 transition-colors cursor-pointer">
                <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-bold px-2 py-0.5 rounded mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <div className="flex items-start gap-3">
                  <img
                    src={updateImages[(idx + 1) % 3]}
                    alt={item.title}
                    className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover flex-shrink-0"
                  />
                  <div className="min-w-0">
                    <h3 className="text-foreground-900 font-semibold text-sm leading-snug mb-1">
                      {item.title}
                    </h3>
                    <p className="text-foreground-400 text-xs">{item.desc}</p>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}